import provider from './config'

export async function login(payload) {
  try {
    const response = await provider.post('auth/autenticacao/', payload)
    return response.data
  } catch (err) {
    if (err.response && err.response.data.message) {
      throw Error(err.response.data.message)
    }

    throw Error('Erro ao logar')
  }
}

export async function getProfile(token) {
  try {
    const response = await provider.get('usuarios/profile', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (err) {
    if (err.response && err.response.data.message) {
      throw Error(err.response.data.message)
    }

    throw Error('Erro ao logar')
  }
}
